const { ASYNC } = require('../utils/redux-helpers');

module.exports = {
    REQUEST_PEER: ASYNC,
    ACCEPT_PEER: ASYNC,
    DISCONNECT_PEER: ASYNC,
    CREATE_TWILIO_CONVERSATION: ASYNC,
    ENABLE_USER: ASYNC,
    CHANGE_USER_ROLE: ASYNC,
    SEND_MESSAGE: ASYNC,
    SEND_ANNOUNCEMENT_MESSAGE: ASYNC,
    MENTION: ASYNC,
    UPDATE_MESSAGE_BODY: ASYNC,
    UPDATE_ANNOUNCEMENT_MESSAGE_BODY: ASYNC,
    SET_ANNOUNCEMENT_LAST_READ_MESSAGE_INDEX: ASYNC,
    MODERATE_MESSAGE: ASYNC,
    PIN_MESSAGE: ASYNC,
    PIN_ANNOUNCEMENT_MESSAGE: ASYNC,
    MODERATE_ANNOUNCEMENT_MESSAGE: ASYNC,
    REMOVE_MESSAGE: ASYNC,
    REMOVE_ANNOUNCEMENT_MESSAGE: ASYNC,
    REMOVE_OWN_MESSAGE: ASYNC,
    SET_LAST_READ_MESSAGE_INDEX: ASYNC,
    SET_LAST_READ_MESSAGE_INDEX_BY_CONVERSATION_SID: ASYNC,
    FLAG_MESSAGE_AS_INAPPROPRIATE: ASYNC,
    FLAG_ANNOUNCEMENT_MESSAGE_AS_INAPPROPRIATE: ASYNC,
    TARGET_NOTIFY_USER: ASYNC,
    BATCH_TARGET_NOTIFY: ASYNC,
    UPLOAD_PREAPPROVED: ASYNC,
    UPLOAD_CHAT_IMAGE: ASYNC
};
